export const sortOptions = ['Cheapest', 'Fastest', 'Best']
export const stopOptions = ['Direct only', '1 stop at most', '2 stops at most', 'Any number of stops']
